import { CATEGORIES_OBJECT, STATUS_OBJECT } from 'constants/variables'
import { RoleFilterKeyString } from '../types'

export function getRoleFilterFeedbacks(value: string) {
  const status = STATUS_OBJECT[value] ? STATUS_OBJECT[value].text : ''
  const category = CATEGORIES_OBJECT[value] ? CATEGORIES_OBJECT[value].name : ''

  const rolesFilterFeedbacks: RoleFilterKeyString = {
    search: `Geral: ${value}`,
    id: `ID: ${value}`,
    name: `Nome: ${value}`,
    status: `Status: ${status}`,
    category: `Categoria: ${category}`,
    role_id: `ID: ${value}`,
    role_name: `Nome: ${value}`,
    role_status: `Status: ${status}`,
    role_category: `Categoria: ${category}`,
  }

  return rolesFilterFeedbacks
}
